import React from "react";

export default function Privacy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-slate-800">
      <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-sm text-slate-500 mb-8">
        Last updated: 22-01-2026
      </p>

      <section className="space-y-6">
        <div>
          <h2 className="text-xl font-semibold mb-2">1. Overview</h2>
          <p>
            ImportDocs complies with the Australian Privacy Act 1988 and
            respects your privacy.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            2. Information We Collect
          </h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Name and email address</li>
            <li>Business information</li>
            <li>Uploaded shipping and import documents</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            3. How We Use Information
          </h2>
          <p>
            We use information to operate the platform, store documents,
            enable sharing, and communicate service updates.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">
            4. Data Storage & Security
          </h2>
          <p>
            Data is stored using secure third-party cloud infrastructure.
            No system is completely secure.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">5. Data Sharing</h2>
          <p>
            We do not sell your data. Information may be shared with hosting,
            payment providers, or legal authorities when required by law.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">6. Your Rights</h2>
          <p>
            You may request access, correction, or deletion of your personal
            information at any time.
          </p>
        </div>
      </section>
    </div>
  );
}
